<template>
  <div>
    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
const default_layout = "default";
export default {
  name: "App",
  
  mounted() {
    this.loadJS();
    this.$store.dispatch('cotation/getMenus');
  }, 
  watch: {
    $route(to, from) {
      //this.loadJS();
      // console.log("Hello from: "+from+" to: "+to);
    }
  },
   computed: {
    layout() {
        return (this.$route.meta.layout || default_layout) + "-layout";
    }
  },
}
</script>
